"use strict";
// @generated by protoc-gen-es v1.10.0 with parameter "target=ts,import_extension=none"
// @generated from file spwn/shipping/v1/legacy_portal_service.proto (package spwn.shipping.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck
Object.defineProperty(exports, "__esModule", { value: true });
exports.LegacyPortalShippingServiceGetLegacyPortalAddressInfoResponse = exports.LegacyPortalShippingServiceGetLegacyPortalAddressInfoRequest = exports.LegacyPortalShippingServiceGetShippingStatusByFulfillmentFirestoreIdResponse = exports.LegacyPortalShippingServiceGetShippingStatusByFulfillmentFirestoreIdRequest = void 0;
const protobuf_1 = require("@bufbuild/protobuf");
const legacy_portal_common_pb_1 = require("./legacy_portal_common_pb");
/**
 * fulfillment_firestore_idを指定して配送状況を取得
 *
 * @generated from message spwn.shipping.v1.LegacyPortalShippingServiceGetShippingStatusByFulfillmentFirestoreIdRequest
 */
class LegacyPortalShippingServiceGetShippingStatusByFulfillmentFirestoreIdRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * FulfillmentのFirestore ID
         *
         * @generated from field: string fulfillment_firestore_id = 1;
         */
        this.fulfillmentFirestoreId = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new LegacyPortalShippingServiceGetShippingStatusByFulfillmentFirestoreIdRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LegacyPortalShippingServiceGetShippingStatusByFulfillmentFirestoreIdRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LegacyPortalShippingServiceGetShippingStatusByFulfillmentFirestoreIdRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(LegacyPortalShippingServiceGetShippingStatusByFulfillmentFirestoreIdRequest, a, b);
    }
}
exports.LegacyPortalShippingServiceGetShippingStatusByFulfillmentFirestoreIdRequest = LegacyPortalShippingServiceGetShippingStatusByFulfillmentFirestoreIdRequest;
LegacyPortalShippingServiceGetShippingStatusByFulfillmentFirestoreIdRequest.runtime = protobuf_1.proto3;
LegacyPortalShippingServiceGetShippingStatusByFulfillmentFirestoreIdRequest.typeName = "spwn.shipping.v1.LegacyPortalShippingServiceGetShippingStatusByFulfillmentFirestoreIdRequest";
LegacyPortalShippingServiceGetShippingStatusByFulfillmentFirestoreIdRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "fulfillment_firestore_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message spwn.shipping.v1.LegacyPortalShippingServiceGetShippingStatusByFulfillmentFirestoreIdResponse
 */
class LegacyPortalShippingServiceGetShippingStatusByFulfillmentFirestoreIdResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new LegacyPortalShippingServiceGetShippingStatusByFulfillmentFirestoreIdResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LegacyPortalShippingServiceGetShippingStatusByFulfillmentFirestoreIdResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LegacyPortalShippingServiceGetShippingStatusByFulfillmentFirestoreIdResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(LegacyPortalShippingServiceGetShippingStatusByFulfillmentFirestoreIdResponse, a, b);
    }
}
exports.LegacyPortalShippingServiceGetShippingStatusByFulfillmentFirestoreIdResponse = LegacyPortalShippingServiceGetShippingStatusByFulfillmentFirestoreIdResponse;
LegacyPortalShippingServiceGetShippingStatusByFulfillmentFirestoreIdResponse.runtime = protobuf_1.proto3;
LegacyPortalShippingServiceGetShippingStatusByFulfillmentFirestoreIdResponse.typeName = "spwn.shipping.v1.LegacyPortalShippingServiceGetShippingStatusByFulfillmentFirestoreIdResponse";
LegacyPortalShippingServiceGetShippingStatusByFulfillmentFirestoreIdResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "shipping_status", kind: "message", T: legacy_portal_common_pb_1.LegacyPortalShippingStatus },
]);
/**
 * @generated from message spwn.shipping.v1.LegacyPortalShippingServiceGetLegacyPortalAddressInfoRequest
 */
class LegacyPortalShippingServiceGetLegacyPortalAddressInfoRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new LegacyPortalShippingServiceGetLegacyPortalAddressInfoRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LegacyPortalShippingServiceGetLegacyPortalAddressInfoRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LegacyPortalShippingServiceGetLegacyPortalAddressInfoRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(LegacyPortalShippingServiceGetLegacyPortalAddressInfoRequest, a, b);
    }
}
exports.LegacyPortalShippingServiceGetLegacyPortalAddressInfoRequest = LegacyPortalShippingServiceGetLegacyPortalAddressInfoRequest;
LegacyPortalShippingServiceGetLegacyPortalAddressInfoRequest.runtime = protobuf_1.proto3;
LegacyPortalShippingServiceGetLegacyPortalAddressInfoRequest.typeName = "spwn.shipping.v1.LegacyPortalShippingServiceGetLegacyPortalAddressInfoRequest";
LegacyPortalShippingServiceGetLegacyPortalAddressInfoRequest.fields = protobuf_1.proto3.util.newFieldList(() => []);
/**
 * @generated from message spwn.shipping.v1.LegacyPortalShippingServiceGetLegacyPortalAddressInfoResponse
 */
class LegacyPortalShippingServiceGetLegacyPortalAddressInfoResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new LegacyPortalShippingServiceGetLegacyPortalAddressInfoResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LegacyPortalShippingServiceGetLegacyPortalAddressInfoResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LegacyPortalShippingServiceGetLegacyPortalAddressInfoResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(LegacyPortalShippingServiceGetLegacyPortalAddressInfoResponse, a, b);
    }
}
exports.LegacyPortalShippingServiceGetLegacyPortalAddressInfoResponse = LegacyPortalShippingServiceGetLegacyPortalAddressInfoResponse;
LegacyPortalShippingServiceGetLegacyPortalAddressInfoResponse.runtime = protobuf_1.proto3;
LegacyPortalShippingServiceGetLegacyPortalAddressInfoResponse.typeName = "spwn.shipping.v1.LegacyPortalShippingServiceGetLegacyPortalAddressInfoResponse";
LegacyPortalShippingServiceGetLegacyPortalAddressInfoResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "legacy_portal_address_info", kind: "message", T: legacy_portal_common_pb_1.LegacyPortalAddressInfo },
]);
//# sourceMappingURL=legacy_portal_service_pb.js.map